import { VehicleUnavailableError } from "../../errors/vehicle-unavailable-error";
const throwErrorByType = (errorBody) => {
    switch (errorBody.errorCode) {
        case 1:
            throw new VehicleUnavailableError();
        default:
            throw new Error(errorBody.message);
    }
};
const handleResponseError = (error) => {
    const response = error.getResponse();
    return response.json().then(throwErrorByType);
};
export default handleResponseError;
